import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import koLocale from 'date-fns/locale/ko'
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { GridRenderCellParams, DataGridPro, GridRowsProp, GridColDef, GridToolbar, useGridApiRef, GridEditRowsModel, GridFilterModel } from '@mui/x-data-grid-pro';
import { eachDayOfInterval } from 'date-fns';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { createStyles, makeStyles } from '@mui/styles';
import styles from '../../componentsStyle/upload.module.css';
import { createTheme, darken, lighten } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import renderCellExpand from '../data/rendercellexpand';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';


const defaultTheme = createTheme();
const useStyles2 = makeStyles(
  (theme) => {
    const getBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    return {
      root: {
        '& .super-app-theme--처리완료': {
          color : "#d3232f"
        },
        '& .super-app-theme--Filled': {
          backgroundColor: getBackgroundColor(theme.palette.success.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
          },
        },
        '& .super-app-theme--확인': {
          color: "#096bde",
        },
        '& .super-app-theme--미확인': {
          backgroundColor: getBackgroundColor(theme.palette.error.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
          },
        },
        '& .timeout': {
          color: theme.palette.error.main,
        },
        '& .transparent': {
          color: "transparent",
        },
      },
    };
  },
  { defaultTheme },
);



const columns: GridColDef[] = [
  { field: 'direction', headerName: '방향', width: 100, renderCell: renderCellExpand, filterable: false },
  { field: 'time', headerName: '시간', width: 120, filterable: false },
  { field: 'name', headerName: '이름', width: 150, renderCell: renderCellExpand },
  { field: 'value', headerName: '출입그룹', width: 150, renderCell: renderCellExpand, filterable: true },
  { field: 'userId', headerName: 'Biostar Id', width: 0, renderCell: renderCellExpand, filterable: true },
];

const TotalFingerprint2: React.FC<any> = (props) => {
  const classes = useStyles2();
  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [alignment, setAlignment] = React.useState('all');

  const apiRef = useGridApiRef();
  const [name, setName] = useState("");
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
      { id: 2, columnField: 'userId', operatorValue: 'equals', value: "" }
    ],
  });

  const start = async (date : number) => {
    var token = "";
    if (window.electron) {
      token = await window.electron.sendMessageApi.getToken();
    }

    fetch("https://peetsunbae.com/fingerprint/totalStamp?date=" + date + "&location=gangnam&locationString=강남점", {
      method: "GET",
      headers: { "Authorization": token },
      credentials: "include",
    }).then((response: any) => {
      response.json()
        .then((result: any) => {
          const data = result.data;
          
          const newRows: any = [];

          if(!data){
            
            return;
          }

          data.sort((after : any, before : any) => {
            if(new Date(+after.time) > new Date(+before.time)){
              return -1;
            }
          })

          data.forEach((each: any, number: number) => {
            const oneRow: any = {};
            oneRow.id = each.id;
            oneRow.userId = each.userId;
            oneRow.name = each.name;
            oneRow.value = each.accessGroup;
            oneRow.direction = each.direction === "outside" ? "ENTER" : "EXIT"
            const createdAt = new Date(+each.time);
            var ampm: string;
            var hours: number;
            if (createdAt.getHours() >= 12) {
              ampm = "오후";
              hours = createdAt.getHours() - 12;
              if (hours === 0) {
                hours = 12;
              }
            } else {
              ampm = "오전";
              hours = createdAt.getHours()
            }
            oneRow.time = `${ampm} ${hours < 10 ? "0" + hours : hours}:${createdAt.getMinutes() < 10 ? "0" + createdAt.getMinutes() : createdAt.getMinutes()}`
            newRows.push(oneRow);
          });
          setRows([...newRows]);
          setLoading(false);
        })
    })
  }


  useEffect(() => {
    setLoading(true);
    

    var date = props.targetDate.getTime();

    start(date);

  }, []);

  const nameChange = (e: any) => {
    
    setName(e.target.value);
    
    const newFilterModel: any = filterModel;
    newFilterModel.items.forEach((each: any) => {
      if (each.id === 2) {
        each.value = e.target.value;
      }
    })
    
    setFilterModel({ ...newFilterModel });
  }

  useEffect(() => {

    if(props.open && props.selectedFingerprintId){
      // const newDate = new Date();
      // setTargetDate(newDate);

      const newFilterModel: any = filterModel;
      newFilterModel.items.forEach((each: any) => {
        if (each.id === 2) {
          each.value = props.selectedFingerprintId;
        }
      })
      
      setFilterModel({ ...newFilterModel });


    }

  }, [props.open, props.selectedFingerprintId]);



  return (
    <div>
      <div style={{marginBottom : "12px", fontSize : "20px", fontFamily : "Apple_R", marginLeft : "12px"}}>
        {
          !props.total
          &&
          new Date().getHours() + "시 " + new Date().getMinutes() + "분 기준"
        }
        {
          props.total
          &&
          new Date(props.targetDate.getTime()).getMonth() + 1 + "월 " + new Date(props.targetDate.getTime()).getDate() + "일 기록"
        }
      </div>
      <div className={classes.root} style={{ height: 400, width: '100%', backgroundColor: "white" }}>

        <DataGridPro loading={loading} rows={rows} columns={columns}
          density='compact'
          filterModel={filterModel}
          apiRef={apiRef}
          onFilterModelChange={(model) => setFilterModel(model)}
          getRowClassName={(params: any) => {
            if (params.getValue(params.id, "direction") === "ENTER") {
              return (
                "super-app-theme--확인"
              )
            } else {
              return (
                "super-app-theme--처리완료"
              )
            }
          }
          }
          getCellClassName={(params) => {
            if(params.field === "userId"){
              return "transparent"
            }else{
              return ""
            }
          }}
        />

      </div>
      <div className={styles.mysearchDescription}>
        
      </div>
    </div>
  )
}

export default TotalFingerprint2;